import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kmOrM'
})
export class KmOrMPipe implements PipeTransform {
  transform(value: any, unit?) {
    if (!value) return;
    if (unit && unit === 'm') value = value / 1000;

    if (value < 1) {
      value = Math.round(value * 1000) + ' m';
    } else {
      value = Math.round(value * 100) / 100 + ' km';
    }
    return value;
  }
}
